import { csFlip } from './csFlip';
/**
 * Flips the value if it is negative of returns the same value otherwise.
 *
 * @param {Number}  i               The value to flip
 *
 * Reference: http://faculty.cse.tamu.edu/davis/publications.html
 */

export function csUnflip(i) {
  // flip the value if it is negative
  return i < 0 ? csFlip(i) : i;
}


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/function/algebra/sparse/csUnflip.js
// module id = 1826
// module chunks = 0